import React, { useEffect, useState } from 'react';
import './Feed.css';
import CreateIcon from '@mui/icons-material/Create';
import InputOption from './InputOption.js';
import ImageIcon from '@mui/icons-material/Image';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import Post from './Post.js';
import { useSelector } from 'react-redux';
import { db } from './firebase.js';
import {
  collection,
  onSnapshot,
  addDoc,
  serverTimestamp,
  orderBy,
  query
} from 'firebase/firestore';
import { motion, AnimatePresence } from 'framer-motion';

function Feed() {
  const user = useSelector((state) => state.user.user);
  const [input, setInput] = useState('');
  const [posts, setPosts] = useState([]);

  // Real-time listener
  useEffect(() => {
    const unsubscribe = onSnapshot(
      query(collection(db, 'posts'), orderBy('timestamp', 'desc')),
      (snapshot) => {
        setPosts(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        );
      }
    );

    return () => unsubscribe();
  }, []);

  // Send a new post
  const sendPost = async (e) => {
    e.preventDefault();

    await addDoc(collection(db, 'posts'), {
      name: user.displayName,
      description: user.email,
      message: input,
      photoUrl: user.photoUrl || '',
      timestamp: serverTimestamp(),
    });

    setInput('');
  };

  return (
    <div className="feed">
      {/* Input section - static, no animation here */}
      <div className="feed_inputContainer">
        <div className="feed_input">
          <CreateIcon />
          <form onSubmit={sendPost}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Start a post"
            />
            <button type="submit">Send</button>
          </form>
        </div>

        <div className="feed_inputOptions">
          <InputOption Icon={ImageIcon} title="Photo" color="#70b5f9" />
          <InputOption Icon={SubscriptionsIcon} title="Video" color="#e7a33e" />
          <InputOption Icon={EventNoteIcon} title="Event" color="#c0cbcd" />
          <InputOption Icon={CalendarViewDayIcon} title="Write article" color="#7fc15e" />
        </div>
      </div>

      {/* Posts container - only this container animates */}
      <div className="feed_postsContainer">
        <AnimatePresence>
          {posts.map(({ id, data: { name, description, message, photoUrl } }) => (
            <motion.div
              key={id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              layout
              transition={{ duration: 0.3 }}
            >
              <Post
                name={name}
                description={description}
                message={message}
                photoUrl={photoUrl}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default Feed;
